import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layout/mypage/Header";
import Footer from "../../layout/mypage/Footer";
import ScreenColorSetting from "../../layout/mypage/ScreenColorSetting";
import { useAuth } from "../../../contexts/AuthContext";
import { DEFAULT_SCREEN_COLOR } from "../../../utils/config";

const Error = () => {
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(DEFAULT_SCREEN_COLOR);
  // ログアウトする
  const { adminLogout, mypageLogout } = useAuth();

  useEffect(() => {
    if (localStorage.userData) {
      let userdata = JSON.parse(localStorage.userData);
      if (userdata.is_admin) {
        adminLogout();
      } else {
        // mypageの場合
        mypageLogout();
      }
    }
  }, [adminLogout, mypageLogout]);

  return (
    <>
      <ScreenColorSetting
        screenColor={screenColor}
        setScreenColor={setScreenColor}
      />
      <div className="mypage-site">
        <Header
          setScreenColor={setScreenColor}
          screenColor={screenColor}
          isLogin={false}
        />

        <main className="l-main">
          <div className="container">
            <div className="col-lg-10 offset-lg-1">
              <h1 className="p-heading01">システムエラーが発生しました。</h1>
              <label className="mb-5">
                サーバが混み合っているか、プログラム誤作動によるエラーが発生しました。
                <br />
                ご迷惑おかけいたしまして、大変申し訳ございません。
                <br />
                しばらく経ってから再度ご利用くださいますようお願い申し上げます。
              </label>
              <div className="p-course-page__btn">
                <Link
                  className="p-course-page__btn-link mt-5"
                  to="/mypage/login"
                >
                  ログイン画面へ戻る
                </Link>
              </div>
            </div>
          </div>
        </main>
        <Footer is_login={true} />
      </div>
    </>
  );
};
export default Error;
